import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, finalize, map } from 'rxjs';
import { LoaderService } from 'app/services/loader/Loader.service';
import { Constants } from 'app/components/utils/Constants';


@Injectable()
export class LoadingInterceptor implements HttpInterceptor {

  private totalRequests = 0;
  
  constructor(private loadingService: LoaderService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const spinner = request.context.get(Constants.SPINNER);
    if(!spinner){
      return next.handle(request);
    }
    this.totalRequests++;
    this.loadingService.setLoading(true);
    return next.handle(request)
    .pipe(
     /* map((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          console.log("event>>>>", event);
          console.log("event.status>>>>", event.status);
          
          this.totalRequests--;
          if (this.totalRequests == 0) {
            this.loadingService.setLoading(false);
          }
        }

        return event;

      })*/
      finalize(() => {
        //console.log("request>>>>", request);
        this.totalRequests--;
        if (this.totalRequests == 0) {
          this.loadingService.setLoading(false);
        }
      })
    );
  }
}
